import { qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import Accordions from '@/lib/accordion';
import { focusFormStatus } from '@/lib/a11y';
import { wrapIframes, wrapTables } from '@/lib/rte';

section('article', {
  onLoad() {
    this.accordions = Accordions(qsa('.accordion', this.container));
    focusFormStatus(this.container);

    wrapIframes(qsa('iframe', this.container));
    wrapTables(qsa('table', this.container));
  },

  onUnload() {
    this.accordions.destroy();
  },
});
